import type { Locale, MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"
import type { ApiRoute, NoQueryParams } from "../api"
import type { IsoDate } from "../common"

export interface AddMarketExportPathParams {
	marketplaceKey: MarketplaceKey
}

export type MarketExportType = "INVENTORY" | "DELIVERED_INVENTORY"

interface AddInventoryMarketExportBody {
	exportType?: Extract<MarketExportType, "INVENTORY">
	locale: Locale
}

interface AddDeliveredInventoryMarketExportBody {
	deliveryEndDate: IsoDate
	deliveryStartDate: IsoDate
	exportType: Extract<MarketExportType, "DELIVERED_INVENTORY">
	locale: Locale
}

export type AddMarketExportBody = AddInventoryMarketExportBody | AddDeliveredInventoryMarketExportBody

export interface MarketExportJobView {
	exportJobId: string
}

export const addMarketExportRoute: ApiRoute<
	AddMarketExportPathParams,
	NoQueryParams,
	AddMarketExportBody,
	MarketExportJobView
> = {
	buildUrl: (params) => `/export-market/${params.marketplaceKey}`,
	method: "post",
	path: "/export-market/:marketplaceKey",
}
